
import {
  computed,
  defineComponent, onBeforeMount, ref, Ref,
} from 'vue';
import { useI18n } from 'vue-i18n';

import {
  getIsAuthenticated, Logout, Me, refreshTokenLogin, Shop, UserState,
} from '@/composables/User';
import { useRouter } from 'vue-router';
import InputText from 'primevue/inputtext';
import { useStore } from '@/store';
import { showToastError } from '@/helpers';

export default defineComponent({
  name: 'ChooseShop',

  components: {
    InputText,
  },

  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const isLoading = ref(false);
    const searchValue = ref('');

    const nbTotalShops = computed(() => UserState.user.shops.length);

    const displayedShops = computed(() => {
      const regex = new RegExp(searchValue.value, 'i');
      return UserState.user.shops
        .filter((s: Shop) => (regex.test(s.name) || regex.test(s.id.toString()) || regex.test(s.url)))
        .slice(0, 10);
    });

    const selectShop = async (shop: Shop) => {
      isLoading.value = true;

      try {
        const res: any = await refreshTokenLogin(shop.id);
        if (res && res.success) {
          const { idShop } = res;
          await Me(true, Number(idShop));
          store.commit('liveEditor/resetWebsiteContents');
          await router.push({ name: 'home' });
        } else {
          await showToastError('GENERIC_ERROR');
        }
      } catch (e) {
        await showToastError('GENERIC_ERROR');
      }

      isLoading.value = false;
    };

    const handleLogout = async () => {
      try {
        await Logout();
      } catch (e) {
        // ignore
      }
      await router.push({ name: 'login' });
      window.location.reload();
    };

    const onImgError = (event: Event) => {
      const img = event.target as HTMLImageElement;
      img.style.display = 'none';
      const parent = img.parentElement;
      if (parent && !parent.querySelector('i')) {
        const icon = document.createElement('i');
        icon.className = 'fa-solid fa-store';
        parent.appendChild(icon);
      }
    };

    onBeforeMount(async () => {
      const isAuthenticated = getIsAuthenticated();
      if (!isAuthenticated) {
        await Me(false);
      }
      return true;
    });

    return {
      t,
      nbTotalShops,
      displayedShops,
      searchValue,
      isLoading,
      selectShop,
      handleLogout,
      onImgError,
    };
  },
});
